import { MessagesSquare } from 'lucide-react'
import { Button } from '#/components/ui/button'
import { m } from '#/paraglide/messages'

/** "Join the Discord community" — rendered only when DISCORD_INVITE_URL is configured. */
export function DiscordCta({ url, compact }: { url: string | null | undefined; compact?: boolean }) {
  if (!url) return null
  if (compact)
    return (
      <Button asChild size="sm" variant="outline" className="gap-2">
        <a href={url} target="_blank" rel="noreferrer noopener">
          <MessagesSquare className="size-4" /> {m.gd_discord_cta()}
        </a>
      </Button>
    )
  return (
    <section className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border bg-card p-5">
      <div className="min-w-0">
        <h2 className="font-heading text-lg font-semibold">{m.gd_discord_title()}</h2>
        <p className="mt-1 max-w-prose text-sm text-muted-foreground">{m.gd_discord_desc()}</p>
      </div>
      <Button asChild className="gap-2">
        <a href={url} target="_blank" rel="noreferrer noopener">
          <MessagesSquare className="size-4" /> {m.gd_discord_cta()}
        </a>
      </Button>
    </section>
  )
}
